import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import CostaricaImage from '../components/costarica.png';
import NorwayImage from '../components/norway.webp';

function Year2018() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
        <h1>2018 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Costa Rica Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/costarica')} // Redirect to /costarica
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${CostaricaImage})` }}
            ></div>
            <p className="location-name">Costa Rica</p>
          </div>
  
          {/* Norway Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/norway')} // Redirect to /norway
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${NorwayImage})` }}
            ></div>
            <p className="location-name">Norway</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2018;